import { render, staticRenderFns } from "./DocumentFilterModal.vue?vue&type=template&id=7106044c&"
import script from "./DocumentFilterModal.vue?vue&type=script&lang=js&"
export * from "./DocumentFilterModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports